import { appActions } from "store/app/appSlice";
import NotificationStatuses from "types/NotificationStatuses";
   
const errorMiddleware = ({ dispatch }:any) => (next:any) => (action:any) => {
  const { type, payload, error } = action;

  if ( type.includes('/rejected') ){
    dispatch(appActions.enqueueSnackbar({
      message: payload?.message || error?.message || 'Невідома помилка',
      options: { variant: NotificationStatuses.Error }
    }));
  }

  return next(action);
}

export default errorMiddleware;
